import { GET_CUSTOMERS, ADD_CUSTOMER, UPDATE_CUSTOMER, UPDATE_CUSTOMER_PAYABLE } from 'redux/actionTypes';

function findCustomerIndex(state, customerId) {
    return state.findIndex(customer => customer.id === customerId);
};

export default function customers(state = [], action) {
    switch(action.type) {
        case GET_CUSTOMERS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_CUSTOMER:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_CUSTOMER:
            const updateIndex = findCustomerIndex(state, action.payload.id);
            return [
                ...state.slice(0, updateIndex),
                action.payload,
                ...state.slice(updateIndex + 1)
            ];
        case UPDATE_CUSTOMER_PAYABLE:
            const payableIndex = findCustomerIndex(state, action.payload.id);
            return [
                ...state.slice(0, payableIndex),
                {
                    ...state[payableIndex],
                    payableAmount: action.payload.payableAmount
                },
                ...state.slice(payableIndex + 1)
            ];
        default:
            return state;
    }
};